import { axios } from '@/services/axios';

export const createTemplate = (templateData) => {
    return axios.post('/AATemplate/', templateData);
};
